import { __ } from '@wordpress/i18n'; // Importeer de internationalisatiefunctie
import { useBlockProps, InspectorControls } from '@wordpress/block-editor'; // Hooks voor blokken en de zijbalk
import { PanelBody, RangeControl } from '@wordpress/components'; // UI-componenten van WordPress
import './editor.scss'; // Importeer de editor-specifieke stylesheet (zorg dat deze bestaat)

/**
 * De bewerkingscomponent voor het Faqs List blok.
 * Dit is wat de gebruiker ziet in de Gutenberg editor.
 *
 * @param {object} props De eigenschappen van het blok.
 * @param {object} props.attributes De attributen van het blok (o.a. 'limit').
 * @param {Function} props.setAttributes Functie om de attributen van het blok bij te werken.
 * @returns {JSX.Element} Het JSX-element dat het blok in de editor representeert.
 */
const Edit = ({ attributes, setAttributes }) => {
    // Destructure het 'limit' attribuut uit de props.
    const { limit } = attributes;

    // Haal de standaard HTML-attributen voor het blok op.
    // Dit zorgt ervoor dat het blok correct wordt weergegeven en werkt binnen de editor.
    const blockProps = useBlockProps();

    return (
        // De hoofdcontainer van het blok in de editor.
        <div {...blockProps}>
            {/* InspectorControls plaatst elementen in de zijbalk van de editor (Block Settings). */}
            <InspectorControls>
                <PanelBody title={__('FAQ Instellingen', 'seoninja_seo')}>
                    {/* RangeControl stelt de gebruiker in staat om een getalbereik te kiezen. */}
                    <RangeControl
                        label={__('Aantal FAQ\'s tonen', 'seoninja_seo')}
                        value={limit} // Huidige waarde van het 'limit' attribuut
                        onChange={(newLimit) => setAttributes({ limit: newLimit })} // Update het attribuut bij wijziging
                        min={1}   // Minimale aantal FAQ's
                        max={50}  // Maximale aantal FAQ's (pas dit indien nodig aan)
                        step={1}  // Stapgrootte voor de slider
                    />
                </PanelBody>
            </InspectorControls>

            {/* Dit is de visuele weergave van het blok in de editor zelf. */}
            <p>
                {__('SeoNinja FAQ\'s Lijst Block', 'seoninja_seo')}
                <br />
                {__(`Er worden momenteel ${limit} FAQ's getoond.`, 'seoninja_seo')}
            </p>
            <p className="description">
                {__('De daadwerkelijke FAQ\'s verschijnen op de front-end.', 'seoninja_seo')}
            </p>
        </div>
    );
};

export default Edit; // Exporteer de Edit-component als standaard export.
